<template>
  <div v-if="AnswerObj.length != 0 && !isRemove">
    <!-- 封面 -->
    <div v-if="typeNum == 1" class="flex-column">
      <p class="hint" style="padding-bottom: 10px">上传孩子头像</p>
      <upload-self
        v-if="AnswerObj[0]"
        :width="267"
        @Success="uploadSuccess"
        :value="AnswerObj[0].Content"
        :height="267"
        type="noBorder"
        :flag="0"
      />
    </div>
    <!-- 记录板式 -->
    <div
      v-if="PlateId == 1 && typeNum == 6"
      class="flex-center"
      style="flex-direction: column"
    >
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[0]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[0].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[0].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(0)">模版列表</div>
          <div @click="addRecommend(0, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
      <upload-self
        v-if="AnswerObj[1]"
        style="margin-top: 25px"
        :width="464"
        :height="261"
        type="noBorder"
        :value="AnswerObj[1].Content"
        @Success="uploadSuccess"
        :flag="1"
      />
      <upload-self
        v-if="AnswerObj[2]"
        style="margin-top: 25px"
        :width="464"
        :height="261"
        type="noBorder"
        :value="AnswerObj[2].Content"
        @Success="uploadSuccess"
        :flag="2"
      />
    </div>
    <!-- 新增图文11样式 -->
    <div v-if="PlateId == 11 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">教师的话</div>
        <div class="flex-between">
          <upload-self
            v-if="AnswerObj[0]"
            :width="224"
            :height="168"
            type="noBorder"
            :value="AnswerObj[0].Content"
            @Success="uploadSuccess"
            :flag="0"
          />
          <upload-self
            v-if="AnswerObj[1]"
            :width="224"
            :height="168"
            type="noBorder"
            :value="AnswerObj[1].Content"
            @Success="uploadSuccess"
            :flag="1"
          />
        </div>
        <div style="margin: 20px auto">
          <!-- <el-input
            v-if="AnswerObj[2]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[2].Content"
            maxlength="200"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="200"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[2].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(2)">模版列表</div>
            <div @click="addRecommend(2, 200)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">家长的话</div>
        <div class="flex-between">
          <upload-self
            v-if="AnswerObj[3]"
            :width="224"
            :height="168"
            type="noBorder"
            :value="AnswerObj[3].Content"
            @Success="uploadSuccess"
            :flag="3"
          />
          <upload-self
            v-if="AnswerObj[4]"
            :width="224"
            :height="168"
            type="noBorder"
            :value="AnswerObj[4].Content"
            @Success="uploadSuccess"
            :flag="4"
          />
        </div>
        <div style="margin: 20px auto">
          <!-- <el-input
            v-if="AnswerObj[5]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[5].Content"
            maxlength="200"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="200"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[5].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(5)">模版列表</div>
            <div @click="addRecommend(5, 200)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增图文12样式 -->
    <div v-if="PlateId == 12 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">教师的话</div>
        <div class="flex-center">
          <upload-self
            v-if="AnswerObj[0]"
            :width="311"
            :height="175"
            type="noBorder"
            :value="AnswerObj[0].Content"
            @Success="uploadSuccess"
            :flag="0"
          />
        </div>
        <div style="margin: 20px auto">
          <!-- <el-input
            v-if="AnswerObj[1]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[1].Content"
            maxlength="200"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="200"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[1].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(1)">模版列表</div>
            <div @click="addRecommend(1, 200)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">家长的话</div>
        <div class="flex-center">
          <upload-self
            v-if="AnswerObj[2]"
            :width="311"
            :height="175"
            type="noBorder"
            :value="AnswerObj[2].Content"
            @Success="uploadSuccess"
            :flag="2"
          />
        </div>
        <div style="margin: 20px auto">
          <!-- <el-input
            v-if="AnswerObj[3]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[3].Content"
            maxlength="200"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="200"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[3].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(3)">模版列表</div>
            <div @click="addRecommend(3, 200)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增图文样式13 -->
    <div v-if="PlateId == 13 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <div class="flex-center">
        <upload-self
          v-if="AnswerObj[0]"
          :width="711"
          :height="900"
          type="noBorder"
          :value="AnswerObj[0].Content"
          @Success="uploadSuccess"
          :flag="0"
        />
      </div>
    </div>
    <div v-if="PlateId == 2 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div class="plateThere" style="justify-content: space-around">
        <upload-self
          v-if="AnswerObj[0]"
          :width="190"
          :height="229"
          type="noBorder"
          :value="AnswerObj[0].Content"
          @Success="uploadSuccess"
          :flag="0"
        />

        <div style="width: 354px">
          <!-- <el-input
            v-if="AnswerObj[1]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[1].Content"
            maxlength="100"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="100"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[1].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(1)">模版列表</div>
            <div>
              <span @click="addRecommend(1, 100)">添加模版</span>
              <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="plateThere" style="justify-content: space-around">
        <div style="width: 354px">
          <!-- <el-input
            v-if="AnswerObj[2]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[2].Content"
            maxlength="100"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="100"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[2].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(2)">模版列表</div>
            <div>
              <span @click="addRecommend(2, 100)">添加模版</span>
              <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
        <upload-self
          v-if="AnswerObj[3]"
          :width="190"
          :height="229"
          type="noBorder"
          :value="AnswerObj[3].Content"
          @Success="uploadSuccess"
          :flag="3"
        />
      </div>
      <div class="plateThere" style="justify-content: space-around">
        <upload-self
          v-if="AnswerObj[4]"
          :width="190"
          :height="229"
          type="noBorder"
          :value="AnswerObj[4].Content"
          @Success="uploadSuccess"
          :flag="4"
        />
        <div style="width: 354px">
          <!-- <el-input
            v-if="AnswerObj[5]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[5].Content"
            maxlength="100"
            show-word-limit
          ></el-input> -->
          <editor
            :textLength="100"
            @change="onClickTest"
            :isDomValue.sync="AnswerObj[5].Content"
          >
          </editor>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(5)">模版列表</div>
            <div @click="addRecommend(5, 100)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="PlateId == 3 && typeNum == 6" class="flex-column">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[0]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[0].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[0].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(6)">模版列表</div>
          <div @click="addRecommend(0, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>

      <upload-self
        v-if="AnswerObj[1]"
        style="margin-top: 25px"
        :width="464"
        :height="350"
        type="noBorder"
        :value="AnswerObj[1].Content"
        @Success="uploadSuccess"
        :flag="1"
      />
    </div>
    <div v-if="(PlateId == 4 || PlateId == 5) && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div :class="PlateId == 4 ? 'plate5' : 'plate6'">
        <upload-self
          v-if="AnswerObj[0]"
          class="avatar-uploader_type5"
          :width="110"
          :height="103"
          style="position: absolute"
          type="noBorder"
          :value="AnswerObj[0].Content"
          @Success="uploadSuccess"
          :flag="0"
        />
        <upload-self
          v-if="AnswerObj[1]"
          class="avatar-uploader_type5"
          :width="100"
          style="position: absolute"
          :height="131"
          type="noBorder"
          :value="AnswerObj[1].Content"
          @Success="uploadSuccess"
          :flag="1"
        />
        <upload-self
          v-if="AnswerObj[2]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="76"
          :height="76"
          type="noBorder"
          :value="AnswerObj[2].Content"
          @Success="uploadSuccess"
          :flag="2"
        />
        <upload-self
          v-if="AnswerObj[3]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="125"
          :height="160"
          type="noBorder"
          :value="AnswerObj[3].Content"
          @Success="uploadSuccess"
          :flag="3"
        />
        <upload-self
          v-if="AnswerObj[4]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="125"
          :height="160"
          type="noBorder"
          :value="AnswerObj[4].Content"
          @Success="uploadSuccess"
          :flag="4"
        />
        <upload-self
          v-if="AnswerObj[5]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="125"
          :height="160"
          type="noBorder"
          :value="AnswerObj[5].Content"
          @Success="uploadSuccess"
          :flag="5"
        />
        <upload-self
          v-if="AnswerObj[6]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="82"
          :height="94"
          type="noBorder"
          :value="AnswerObj[6].Content"
          @Success="uploadSuccess"
          :flag="6"
        />
        <upload-self
          v-if="AnswerObj[7]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="124"
          :height="143"
          type="noBorder"
          :value="AnswerObj[7].Content"
          @Success="uploadSuccess"
          :flag="7"
        />
        <upload-self
          v-if="AnswerObj[8]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="68"
          :height="117"
          type="noBorder"
          :value="AnswerObj[8].Content"
          @Success="uploadSuccess"
          :flag="8"
        />
        <upload-self
          v-if="AnswerObj[9]"
          class="avatar-uploader_type5"
          style="position: absolute"
          :width="68"
          :height="56"
          type="noBorder"
          :value="AnswerObj[9].Content"
          @Success="uploadSuccess"
          :flag="9"
        />
      </div>
    </div>
    <div
      v-if="PlateId == 6 && typeNum == 6"
      style="flex-direction: column"
      class="flex-center"
    >
      <upload-self
        v-if="AnswerObj[0]"
        style="margin-bottom: 25px"
        :width="469"
        :height="350"
        type="noBorder"
        :value="AnswerObj[0].Content"
        @Success="uploadSuccess"
        :flag="0"
      />
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[1]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[1].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[1].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(1)">模版列表</div>
          <div>
            <span @click="addRecommend(1, 250)">添加模版</span>
            <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="PlateId == 7 && typeNum == 6"
      class="flex-center"
      style="flex-direction: column"
    >
      <div style="width: 464px; margin: 0 auto">
        <div class="title">
          <span>{{ title }}</span>
        </div>
        <upload-self
          v-if="AnswerObj[0]"
          style="margin-top: 25px"
          :width="464"
          :height="261"
          type="noBorder"
          :value="AnswerObj[0].Content"
          @Success="uploadSuccess"
          :flag="0"
        />

        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 26px;
          "
        >
          <upload-self
            v-if="AnswerObj[1]"
            :width="224"
            :height="271"
            type="noBorder"
            :value="AnswerObj[1].Content"
            @Success="uploadSuccess"
            :flag="1"
          />
          <upload-self
            v-if="AnswerObj[2]"
            :width="224"
            :height="271"
            type="noBorder"
            :value="AnswerObj[2].Content"
            @Success="uploadSuccess"
            :flag="2"
          />
        </div>
      </div>
      <div style="width: 711px; padding-top: 26px">
        <!-- <el-input
          v-if="AnswerObj[3]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[3].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[3].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(3)">模版列表</div>
          <div @click="addRecommend(3, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="PlateId == 8 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 524px;
          margin: 0 auto;
        "
      >
        <upload-self
          v-if="AnswerObj[0]"
          :width="271"
          :height="414"
          type="noBorder"
          :value="AnswerObj[0].Content"
          @Success="uploadSuccess"
          :flag="0"
        />
        <div>
          <upload-self
            v-if="AnswerObj[1]"
            :width="181"
            :height="134"
            type="noBorder"
            :value="AnswerObj[1].Content"
            @Success="uploadSuccess"
            :flag="1"
          />
          <upload-self
            v-if="AnswerObj[2]"
            style="margin-top: 10px"
            :width="181"
            :height="134"
            type="noBorder"
            :value="AnswerObj[2].Content"
            @Success="uploadSuccess"
            :flag="2"
          />
          <upload-self
            v-if="AnswerObj[3]"
            style="margin-top: 10px"
            :width="181"
            :height="134"
            type="noBorder"
            :value="AnswerObj[3].Content"
            @Success="uploadSuccess"
            :flag="3"
          />
        </div>
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[4]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[4].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[4].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(4)">模版列表</div>
          <div @click="addRecommend(4, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="PlateId == 9 && typeNum == 6"
      style="flex-direction: column"
      class="flex-center"
    >
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>

      <upload-self
        v-if="AnswerObj[0]"
        :width="469"
        @Success="uploadSuccess"
        :height="261"
        type="noBorder"
        v-model="AnswerObj[0].Content"
        :flag="0"
      />
      <!--  -->
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          type="textarea"
          v-if="AnswerObj[1]"
          :rows="4"
          @input="uploadSuccess"
          v-model="AnswerObj[1].Content"
          placeholder="请输入内容"
          maxlength="250"
          show-word-limit
        ></el-input> -->

        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[1].Content"
        >
        </editor>
        <!-- <el-button type="primary" @click="onClickTest">测试按钮</el-button> -->
        <div class="textPlate">
          <div @click="setectTextList(1)">模版列表</div>
          <div @click="addRecommend(1, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="PlateId == 10 && typeNum == 6">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[0]"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          @input="uploadSuccess"
          v-model="AnswerObj[0].Content"
          maxlength="450"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="450"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[0].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(0)">模版列表</div>
          <div @click="addRecommend(0, 450)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 视频 -->
    <div
      v-if="typeNum == 9"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <upload-self
        v-if="AnswerObj[0]"
        action="/api/Img/UploadFile/"
        :width="469"
        @Success="uploadSuccess"
        :value="AnswerObj[0].Content"
        :height="267"
        type="noBorder"
        fileType="video"
        :flag="0"
      />
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <!-- <el-input
          v-if="AnswerObj[1]"
          type="textarea"
          @input="uploadSuccess"
          :rows="4"
          placeholder="请输入内容"
          v-model="AnswerObj[1].Content"
          maxlength="250"
          show-word-limit
        ></el-input> -->
        <editor
          :textLength="250"
          @change="onClickTest"
          :isDomValue.sync="AnswerObj[1].Content"
        >
        </editor>
        <div class="textPlate">
          <div @click="setectTextList(1)">模版列表</div>
          <div @click="addRecommend(1, 250)">
            <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 视频样式12 -->
    <div v-if="typeNum == 13">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">教师的话</div>
        <div class="flex-center">
          <upload-self
            v-if="AnswerObj[0]"
            action="/api/Img/UploadFile/"
            :width="311"
            :height="175"
            @Success="uploadSuccess"
            :value="AnswerObj[0].Content"
            type="noBorder"
            fileType="video"
            :flag="0"
          />
        </div>
        <div style="margin: 20px auto">
          <el-input
            v-if="AnswerObj[1]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[1].Content"
            maxlength="250"
            show-word-limit
          ></el-input>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(1)">模版列表</div>
            <div @click="addRecommend(1, 250)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style="padding: 0 0 13px 0; font-size: 18px">家长的话</div>
        <div class="flex-center">
          <upload-self
            v-if="AnswerObj[2]"
            action="/api/Img/UploadFile/"
            :width="311"
            :height="175"
            @Success="uploadSuccess"
            :value="AnswerObj[2].Content"
            type="noBorder"
            fileType="video"
            :flag="2"
          />
        </div>
        <div style="margin: 20px auto">
          <el-input
            v-if="AnswerObj[3]"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            @input="uploadSuccess"
            v-model="AnswerObj[3].Content"
            maxlength="250"
            show-word-limit
          ></el-input>
          <div class="textPlate" style="margin-top: 10px">
            <div @click="setectTextList(3)">模版列表</div>
            <div @click="addRecommend(3, 250)">
              <span>添加模版</span> <img src="@/assets/rightA.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 结语 -->
    <div class="" v-if="typeNum == 10">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <div style="width: 711px; margin: 0 auto; margin-top: 14px">
        <el-input
          v-if="AnswerObj[0]"
          type="textarea"
          @input="uploadSuccess"
          :rows="4"
          placeholder="请输入内容"
          v-model="AnswerObj[0].Content"
          maxlength="450"
          show-word-limit
        ></el-input>
        <div class="textPlate">
          <div></div>
          <div>
            <span @click="GetEpilogueList">选取文字</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 体检 -->
    <div v-if="typeNum == 8" class="flex-column">
      <div class="title">
        <span>{{ title }}</span>
        <!-- <img @click="editTitle" src="@/assets/edit.png" alt="" /> -->
      </div>
      <upload-self
        v-if="AnswerObj[0]"
        :width="469"
        @Success="uploadSuccess"
        :value="AnswerObj[0].Content"
        :height="267"
        type="noBorder"
        :flag="0"
      />
      <div style="width: 469px; margin: 0 auto">
        <div class="time">
          <div>体检时间：</div>
          <el-date-picker
            size="mini"
            v-if="AnswerObj[1]"
            v-model="AnswerObj[1].Content"
            type="date"
            @change="uploadSuccess"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
        <div class="physical" style="margin-top: 0">
          <div
            class="physicalItem"
            v-for="(item, index) in ContentObj"
            :key="index"
          >
            <div style="text-align: right">{{ item.title }}：</div>
            <div v-if="item.topicType == 'radio'" class="radioBox">
              <el-radio
                v-for="(radio, indexRadio) in item.answerList"
                :key="indexRadio"
                v-model="AnswerObj[index + 2].Content"
                :label="radio.value"
                @input="inputChange($event, index + 2)"
                >{{ radio.title }}</el-radio
              >
            </div>
            <el-input
              v-if="AnswerObj[index + 2] && item.topicType != 'radio'"
              @input="uploadSuccess"
              style="width: 120px"
              type="text"
              v-model="AnswerObj[index + 2].Content"
              size="mini"
            />
            <div class="unit" style="padding-left: 5px">
              {{ item.unit }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 运动 -->
    <div v-if="typeNum == 7" class="flex-column">
      <div v-for="(item, index) in ContentObj" :key="index">
        <div class="exerciseTitle">{{ item.title }}</div>
        <div style="display: flex; align-items: center">
          <upload-self
            v-if="AnswerObj[index]"
            :value="AnswerObj[index].Content"
            @Success="uploadSuccess"
            :flag="index"
          />
          <div class="exerciseInfo">
            <p>标准值：{{ item.standardValues }}{{ item.unit }}</p>
            <p>
              实际：<el-input
                @input="uploadSuccess"
                size="mini"
                v-if="AnswerObj[index]"
                v-model="AnswerObj[index].Value"
                style="width: 80px"
              ></el-input>
              {{ AnswerObj[index].unit }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="模版列表"
      append-to-body
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div v-if="GrowthMessageTextLists.length != 0">
        <div
          class="flexs_dis"
          v-for="(item, index) in GrowthMessageTextLists"
          :key="index"
          @click="UseGrowthMessage(item.GrowthMessageText)"
        >
          <div class="li">
            模板{{ index + 1 }}：{{ item.GrowthMessageText }}
          </div>
          <div class="icons" v-if="item.type == false">
            <div
              class="icon"
              style="cursor: pointer"
              @click.stop="DeleteGrowthMessage(item)"
            >
              <i class="el-icon-delete" style="font-size: 20px"></i>
            </div>
          </div>
        </div>
      </div>
      <div v-else>暂无文字模板</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="模版列表"
      append-to-body
      :visible.sync="GetEpilogueListDialogVisible"
      width="30%"
    >
      <div v-if="GetEpilogueListArr.length != 0">
        <div
          class="flexs_dis"
          v-for="(item, index) in GetEpilogueListArr"
          :key="index"
          @click="UseEpilogue(item)"
        >
          <div class="li">模板{{ index + 1 }}：{{ item }}</div>
        </div>
      </div>
      <div v-else>暂无文字模板</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="GetEpilogueListDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="GetEpilogueListDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加模板 -->
    <el-dialog
      title="添加文字模板"
      :visible.sync="textDialogVisible"
      width="30%"
      append-to-body
    >
      <div>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="textMessage"
          :maxlength="textLen"
          show-word-limit
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="textDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickMessageSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  FrontGetMessageTemplateList,
  FrontAddMessageTemplate,
  GetEpilogueList,
  GetStudentPhysicalInfo,
  SaveDetailInfo,
  FrontDeleteMessageTemplate,
} from "@/api/api";
import uploadSelf from "@/components/upload_self";
import Editor from "../../components/Editor/index.vue";

export default {
  props: {
    typeNum: {
      default: 0,
    },
    PlateId: {
      default: 0,
    },
    tempDetailId: {
      default: 0,
    },
    CustomerId: {
      default: "",
    },
    TempId: {
      default: "",
    },
    TeacherId: {
      default: "",
    },
    Answer: {
      Type: String,
      default: "",
    },
    Content: {
      Type: String,
      default: "",
    },
    title: {
      Type: String,
      default: "121212",
    },
  },
  data() {
    return {
      textarea: "",
      action: "",
      url: "",
      value1: "",
      AnswerObj: [],
      ContentObj: [],
      GrowthMessageTextLists: [], //文字模板
      dialogVisible: false,
      textIndex: 0,
      isRemove: false,
      GetEpilogueListArr: [],
      GetEpilogueListDialogVisible: false,
      textDialogVisible: false,
      textLen: 0,
      textMessage: "",
      isShowEdit: false,
    };
  },
  components: {
    uploadSelf,
    Editor,
  },
  watch: {
    // Content() {
    //   this._initData();
    // },
    // Answer() {
    //   this._initData();
    // },

    PlateId() {
      this.isRemove = true;
      this._initData();
      this.isRemove = false;
    },
    typeNum() {
      this.isRemove = true;
      this._initData();
      this.isRemove = false;
    },
  },
  async created() {
    console.log(this.AnswerObj);
    //console.log(this.Answer, "asd1111111111111111111asd");
    if (this.Answer == "" && this.typeNum == 8) {
      await this.GetStudentPhysicalInfo();
    } else {
      this._initData();
    }

    this.getRecommend();
  },
  destroyed() {
    this.$set(this, "ContentObj", []);
    this.$set(this, "AnswerObj", []);
  },
  methods: {
    onClickTest(e) {
      this.$emit("IsChange", this.AnswerObj);
    },
    async addFn() {
      if (this.typeNum == 8) {
        if (!this.AnswerObj) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        //体检
        let textArr = this.AnswerObj.filter((item) => {
          return item.Content === "";
        });
        if (textArr.length != 0) {
          this.$message.warning("请完整填写体检记录");
          return;
        }
      }
      console.log(this.AnswerObj[1].Content, "AnswerObj[1].Content");
      let xhr = await SaveDetailInfo({
        TempId: this.TempId,
        TeacherId: this.TeacherId,
        tempDetailId: this.tempDetailId,
        answer: JSON.stringify(this.AnswerObj),
        studentId: this.CustomerId,
        type: this.typeNum,
      });
      if (xhr.data.success) {
        this.$message.success("保存成功");
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async GetStudentPhysicalInfo() {
      let res = await GetStudentPhysicalInfo({
        Id: this.CustomerId,
      });
      if (res.data.success) {
        this.ContentObj = JSON.parse(this.Content);
        let AnswerObj = [];
        //体检板块
        this.ContentObj = this.ContentObj.filter((item) => {
          //过滤掉未开启的
          return item.isOpen;
        });
        let arr = [];
        this.ContentObj.forEach((item) => {
          //找出子集
          if (item.child) {
            arr.push(...item.child);
          } else {
            arr.push(item);
          }
        });
        this.ContentObj = arr;
        //console.log(arr);

        //体检
        AnswerObj = [
          {
            Content: require("../../assets/no-data.png"),
            Value: "",
            Time: "",
            Type: "image",
            Describe: "体检上传的图片",
          },
          {
            Content: res.data.response.Time,
            Value: "",
            Time: "",
            Type: "time",
            Describe: "体检时间",
          },
          {
            Content: String(res.data.response.Height),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "CM",
          },
          {
            Content: String(res.data.response.Weight),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "KG",
          },
          {
            Content: String(res.data.response.VisionLeft),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "",
          },
          {
            Content: String(res.data.response.VisionRight),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "",
          },
          {
            Content: res.data.response.HearingLeft ? "1" : "0",
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "",
            topicType: "radio",
          },
          {
            Content: res.data.response.HearingRight ? "1" : "0",
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "",
            topicType: "radio",
          },
          {
            Content: String(res.data.response.Tooth),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "颗",
          },
          {
            Content: String(res.data.response.Hemoglobin),
            Describe: "体检的值",
            Time: "",
            Type: "physical",
            Value: "",
            isShowCheck: false,
            unit: "g/L",
          },
        ];

        this.$set(this, "AnswerObj", AnswerObj);
        await this.addFn();
        console.log(this.AnswerObj, "AnswerObj");
      } else {
        this._initData();
      }
    },
    setRadio(val) {
      return Number(val);
    },
    UseEpilogue(item) {
      this.AnswerObj[0].Content = item;
      this.GetEpilogueListDialogVisible = false;
      this.$emit("change", this.AnswerObj);
    },
    async GetEpilogueList() {
      let xhr = await GetEpilogueList({
        CustomerId: this.CustomerId,
        TempId: this.TempId,
        TeacherId: this.TeacherId,
        IsWeb: 1,
      });
      if (xhr.data.success) {
        this.GetEpilogueListDialogVisible = true;
        this.GetEpilogueListArr = xhr.data.response;
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
    DeleteGrowthMessage(item) {
      if (!item.type) {
        FrontDeleteMessageTemplate({
          ids: [item.Id],
        }).then((res) => {
          if (res.data.success) {
            this.getRecommend();
            this.$message({
              type: "success",
              message: "已删除",
            });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "此条不可删除",
        });
      }
    },
    UseGrowthMessage(text) {
      this.AnswerObj[this.textIndex].Content = text;
      this.dialogVisible = false;
    },
    setectTextList(index) {
      this.dialogVisible = true;
      this.textIndex = index;
    },
    //
    inputChange(e, index) {
      this.AnswerObj[index].Content = String(e);
      this.$emit("change", this.AnswerObj);
    },
    onClickMessageSubmit() {
      FrontAddMessageTemplate({
        Content: this.textMessage,
        MessageType: "成长足迹",
      }).then((res) => {
        if (res.data.success) {
          this.getRecommend();
          this.$message({
            type: "success",
            message: "添加成功",
          });
        }
      });
    },
    addRecommend(num, len) {
      if (this.GrowthMessageTextLists.length > 15) {
        this.textDialogVisible = true;
        this.textLen = len;
      } else {
        this.$message({
          type: "info",
          message: "最多存在15条模板,如需替换请先删除",
        });
      }
    },
    async getRecommend() {
      let res = await FrontGetMessageTemplateList({
        PageSize: 100,
        MessageType: "成长足迹",
      });
      if (res.data.success) {
        this.GrowthMessageTextLists = res.data.response.data;
        //console.log(this.GrowthMessageTextLists);
      } else {
        this.GrowthMessageTextLists = [];
      }
    },
    _initData() {
      try {
        this.AnswerObj = JSON.parse(this.Answer);
      } catch (error) {
        this.AnswerObj = [];
      }
      if (this.Content && (this.typeNum == 7 || this.typeNum == 8)) {
        try {
          this.ContentObj = JSON.parse(this.Content);
          //console.log(this.Content, this.AnswerObj, "this.Content123");

          if (this.typeNum == 8) {
            //体检板块
            this.ContentObj = this.ContentObj.filter((item) => {
              //过滤掉未开启的
              return item.isOpen;
            });
            let arr = [];
            this.ContentObj.forEach((item) => {
              //找出子集
              if (item.child) {
                arr.push(...item.child);
              } else {
                arr.push(item);
              }
            });
            this.ContentObj = arr;
          }
        } catch (error) {
          this.ContentObj = [];
        }
      }
      let AnswerObj = [];
      if (this.AnswerObj.length == 0) {
        if (this.typeNum == 1) {
          //封面
          AnswerObj = [
            {
              Content: "",
              Value: "",
              Type: "image",
              Time: "",
              Describe: "图片",
            },
          ];
          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 7) {
          //运动
          //console.log(this.ContentObj, " this.ContentObj");
          this.ContentObj.forEach((item) => {
            AnswerObj.push({
              Content: item.imageArr[0].url,
              Value: "",
              Time: "",
              Type: "exercise",
              Describe: "运动记录的值",
            });
          });
          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 8) {
          //体检
          AnswerObj = [
            {
              Content: "",
              Value: "",
              Time: "",
              Type: "image",
              Describe: "体检上传的图片",
            },
            {
              Content: "",
              Value: "",
              Time: "",
              Type: "time",
              Describe: "体检时间",
            },
          ];
          this.ContentObj.forEach((item) => {
            let unit = "";
            if (item.unit) {
              unit = item.unit;
            } else {
              if (item.title == "身高") {
                unit = "CM";
              } else if (item.title == "体重") {
                unit = "KG";
              } else if (item.title == "龋齿") {
                unit = "颗";
              } else if (item.title == "血色素") {
                unit = "g/L";
              }
            }
            AnswerObj.push({
              Content: item.topicType == "radio" ? 1 : "",
              Value: "",
              Time: "",
              Type: "physical",
              Describe: "体检的值",
              unit: unit,
            });
          });
          //console.log(AnswerObj, "AnswerObj1");

          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 9) {
          //视频
          AnswerObj = [
            {
              Content: "",
              Value: "",
              Type: "video",
              Time: "",
              Describe: "视频",
            },
            {
              Content: "",
              Value: "",
              Type: "text",
              Time: "",
              Describe: "文字",
            },
          ];
          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 13) {
          //视频
          AnswerObj = [
            {
              Content: "",
              Value: "",
              Time: "",
              Type: "video",
              Describe: "视频",
            },

            {
              Content: "",
              Value: "",
              Time: "",
              Type: "text",
              Describe: "文字",
            },

            {
              Content: "",
              Value: "",
              Time: "",
              Type: "video",
              Describe: "视频",
            },
            {
              Content: "",
              Value: "",
              Time: "",
              Type: "text",
              Describe: "文字",
            },
          ];
          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 10) {
          AnswerObj = [
            {
              Content: "",
              Value: "",
              Type: "text",
              Time: "",
              Describe: "文字",
            },
          ];
          this.$set(this, "AnswerObj", AnswerObj);
        } else if (this.typeNum == 6) {
          //console.log(this.PlateId, "121212");
          //图文
          if (this.PlateId == 1) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 2) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },

              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 3) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 5 || this.PlateId == 4) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 6) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 7) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 8) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 9) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 10) {
            //console.log("1212121212");
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 11) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 12) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },

              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },

              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "text",
                Describe: "文字",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          } else if (this.PlateId == 13) {
            AnswerObj = [
              {
                Content: "",
                Value: "",
                Time: "",
                Type: "image",
                Describe: "图片",
              },
            ];
            this.$set(this, "AnswerObj", AnswerObj);
          }
        }
      }
      this.isShowEdit = true;
      console.log(this.AnswerObj, "this.AnswerObj");
    },
    uploadSuccess(res, flag) {
      if (flag != undefined) {
        this.AnswerObj[flag].Content = res.response ? res.response : res.url;
      }
      console.log(this.AnswerObj, "resaaaaaaaaaaa");
      this.$emit("IsChange", this.AnswerObj);
    },
    // handleAvatarSuccess() {
    //   this.$emit("change", this.AnswerObj);
    // },
    beforeAvatarUpload() {},

    editTitle() {
      this.$prompt("修改标题", {
        confirmButtonText: "确认修改",
        cancelButtonText: "取消",
        inputType: "input",
        inputValue: "",
      }).then(async (res) => {
        if (res.action == "confirm" && res.value) {
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.flexs_dis {
  display: flex;
  justify-content: space-between;
  border: 1px dashed #333;
  margin-top: 4px;
  padding: 10px;
  border-radius: 4px;
  .li {
    font-weight: 600;
    cursor: pointer;
  }
  .icons {
    display: flex;
  }
}
.exerciseInfo {
  padding-left: 41px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.exerciseTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  line-height: 28px;
}
.time {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.physical {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.physical > .physicalItem {
  width: 50%;
  display: flex;
  margin-top: 15px;
  align-items: center;
  color: #333333;
  font-size: 14px;
  .radioBox {
    display: flex;
  }
}
.textPlate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #3558b9;
  margin-top: 20px;
  cursor: pointer;
  div {
    cursor: pointer;
  }
  img {
    width: 7px;
    height: auto;
    margin-left: 5px;
    transform: translateY(1px);
  }
}
.title {
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  //   margin-top: 30px;
  span {
    width: 323px;
    height: 40px;
    background: #eaeaea;
    border-radius: 10px;
    line-height: 40px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
  img {
    width: 32px;
    height: auto;
    margin-left: 25px;
  }
}

.plateThere {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.avatar-uploader3 {
  width: 174px;
  height: 166px;
  margin: 0 auto;
  background: #ededed;
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 174px;
    height: 166px;
    line-height: 166px;
    text-align: center;
  }
}
.plate5 {
  width: 405px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  .avatar-uploader_type5 {
    position: absolute;
  }
  .avatar-uploader_type5:nth-child(1) {
    background: #ededed;
    left: 80px;
    top: 26px;
  }
  .avatar-uploader_type5:nth-child(2) {
    left: 207px;
    top: 0;
  }
  .avatar-uploader_type5:nth-child(3) {
    left: 326px;
    top: 55px;
  }
  .avatar-uploader_type5:nth-child(4) {
    left: 0;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(5) {
    left: 140px;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(6) {
    left: 280px;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(7) {
    left: 92px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(8) {
    left: 191px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(9) {
    left: 332px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(10) {
    left: 332px;
    top: 454px;
  }
}
.plate6 {
  width: 405px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  .avatar-uploader_type5 {
    position: absolute;
  }
  .avatar-uploader_type5:nth-child(1) {
    right: 80px;
    top: 26px;
  }
  .avatar-uploader_type5:nth-child(2) {
    right: 207px;
    top: 0;
  }
  .avatar-uploader_type5:nth-child(3) {
    right: 326px;
    top: 55px;
  }
  .avatar-uploader_type5:nth-child(4) {
    right: 0;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(5) {
    right: 140px;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(6) {
    right: 280px;
    top: 148px;
  }
  .avatar-uploader_type5:nth-child(7) {
    right: 92px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(8) {
    right: 191px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(9) {
    right: 332px;
    top: 321px;
  }
  .avatar-uploader_type5:nth-child(10) {
    right: 332px;
    top: 454px;
  }
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>